import React, {Component} from 'react'
import { connect } from 'react-redux'

// elements
import Inline from '../../elements/inline'
import DropDown from '../../elements/dropDown'
import Text from '../../elements/text'

// import styles
import './phone.scss'

class Phone extends Component {

  constructor (props) {
    super(props)
    this.state = {
      PhoneNumber: '',
      PhoneCode: {
        Id: 1,
        Code: '',
        MinNrLength: 0,
        MaxNrLength: 0
      }
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    let codeId = 1
    if (this.props.code !== null) {
      if (typeof this.props.code.Id !== 'undefined') codeId = this.props.code.Id
    }
    this.setState({
      PhoneCode: {
        ...this.PhoneCode,
        Id: codeId
      },
      PhoneNumber: this.props.number
    })
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.phonecodes.length === 0) {
      console.log('No phone codes!', this.props)
    }
    let codeId = 1
    if (nextProps.code !== null) {
      if (typeof nextProps.code.Id !== 'undefined') codeId = nextProps.code.Id
    }
    this.setState({
      PhoneCode: {
        ...this.PhoneCode,
        Id: codeId
      },
      PhoneNumber: nextProps.number
    })
  }

  onInputChange (e) {
    let value = e.target.value
    if (e.target.name === 'PhoneNumber') e.persist()
    if (e.target.name === 'PhoneCode') {
      value = {
        ...this.state.phoneCode,
        Id: e.target.value
      }
    }
    this.setState({
      [e.target.name]: value
    }, () => {
      this.props.onChange({
        target: {
          name: e.target.name,
          value: value
        }
      })
    })
  }

  onBlur (e) {
    if (typeof this.props.onBlur !== 'undefined') {
      this.props.onBlur({
        target: {
          name: e.target.name,
          value: e.target.value
        }
      })
    }
  }

  render () {
    const renderCodes = (val, key) => {
      return (
        <option key={key} value={val.Id}>{val.Code}</option>
      )
    }
    return (
      <div className='phone'>
        <Inline>
          <DropDown name='PhoneCode' onChange={this.onInputChange} value={this.state.PhoneCode.Id} disabled={this.props.disabled || false}>
            {this.props.phonecodes.map(renderCodes)}
          </DropDown>
          <Text
            id={this.props.Id}
            className={this.props.PhoneNumberClassName}
            name='PhoneNumber'
            onChange={this.onInputChange}
            onBlur={this.onBlur}
            value={this.state.PhoneNumber}
            disabled={this.props.disabled || false}
            placeholder={this.props.placeholder}
            min={this.props.min}
            max={this.props.max} />
        </Inline>
      </div>
    )
  }

}

Phone.defaultProps = {
  PhoneNumberClassName: ''
}

function mapStateToProps (state) {
  return {
    phonecodes: state.common.phonecodes
  }
}

export default connect(mapStateToProps, {})(Phone)



// WEBPACK FOOTER //
// ./src/app/shared/components/Phone/index.js